export default {
  enabledWorkplaces: 'Włączone miejsca pracy',
  selectAll: 'Zaznacz wszystko',
  deselectAll: 'Odznacz wszystko',
};
